import {ButtonListSelectField, EditorModal} from 'forms-editable';
import {CrudStatus, StatusOverlay} from 'forms-crud';
import {PwsHomePageProductData} from './types';
import {SelectField} from 'forms';
import React from 'react';
import t from 'rcm-i18n';

interface Props {
    currentProductIndex: number;
    isOpen: boolean;
    onCancel: () => void;
    onChangeCount: (productCount: string) => void;
    onSelectProduct: (newProductId: string) => void;
    productCount: number;
    productIds: string[];
    productOptions: PwsHomePageProductData[];
    status: CrudStatus;
}

const ProductsEditor = ({
    currentProductIndex,
    isOpen,
    onCancel,
    onChangeCount,
    onSelectProduct,
    productCount,
    productIds,
    productOptions,
    status,
}: Props) => <>
    <div className="row select-product-count">
        <div className="col-xs-12 form-inline">
            <SelectField
                disabled={status === 'saving'}
                className="pull-right"
                label={`${t('Select Product Qty')}\xa0`}
                onValueChange={onChangeCount}
                options={[
                    {
                        label: '3',
                        value: 3,
                    },
                    {
                        label: '6',
                        value: 6,
                    },
                ]}
                value={`${productCount}`}
            />
            <br />
        </div>
    </div>
    <EditorModal field={ButtonListSelectField}
        disabled={status === 'saving'}
        fieldProps={{
            options: productOptions
                .filter((o) => o && o.skuOptions.length > 0)
                .map((o) => ({
                    label: <div className="col-xs-12 col-sm-9">
                        <div className="imageContainer">
                            <img src={o.image} />
                        </div>
                        <div className="header">{o.name}</div>
                    </div>,
                    value: o.productId,
                })),
        }}
        head={<h1 className="modal-title">
            {t('Choose a Product')}
        </h1>}
        isOpen={isOpen}
        onCancel={onCancel}
        onValueChange={onSelectProduct}
        submitOnChange={true}
        value={productIds[currentProductIndex] || null}
    />
    <StatusOverlay status={status} />
</>;

export default ProductsEditor;
